import React from 'react';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

export const claimIcon = (
  value: boolean,
  selected: string,
  disabled: string
) => (
  <LibraryBooksIcon
    style={{ width: '21', marginLeft: '-3px', marginRight: '-3px', color: value ? selected : disabled }}
    id="iconMenu-icon-claim"
  />
);
